

// object to store loaded CSS chunks
var installedCssChunks = {
	3057: 0,
	6416: 0
};
__webpack_require__.f.compat = function(chunkId, promises) {


	// mini-css-extract-plugin CSS loading
	var cssChunks = {"1895":1,"4464":1};
	if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
	else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
		promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
			var href = "css/" + ({"213":"locale-ro-RO","515":"locale-lo-LA","526":"privacyPolicyPage","771":"locale-pt-PT","782":"locale-bn-IN","797":"locale-uk-UA","863":"locale-lv-LV","967":"vibrant","1234":"locale-nb-NO","1434":"locale-cs-CZ","1496":"locale-sq-AL","1723":"locale-th-TH","1854":"locale-zh-CN","1895":"notFoundPage","2009":"classroomPage","2189":"locale-ta-IN","2330":"locale-vi-VN","2357":"locale-it-IT","2423":"locale-sr-Latn-RS","2426":"locale-zh-HK","2684":"locale-ja-JP","3306":"locale-gu-IN","3387":"locale-ka-GE","3481":"locale-az-Latn-AZ","3640":"locale-ar-EG","3783":"locale-fr-FR","3787":"locale-nl-NL","3849":"locale-mn-MN","3938":"locale-kk-KZ","3948":"locale-sl-SI","4215":"locale-he-IL","4464":"faqPage","4744":"exportPage","4832":"howler","4993":"locale-hi-IN","5055":"locale-da-DK","5270":"locale-ko-KR","5323":"locale-lt-LT","6093":"locale-ms-MY","6108":"locale-et-EE","6167":"locale-es-ES","6295":"locale-tr-TR","6433":"locale-en-PI","6551":"locale-hr-HR","6679":"locale-mk-MK","7050":"translationsPage","7093":"locale-id-ID","7156":"locale-cy-GB","7176":"locale-fil-PH","7179":"locale-fa-IR","7573":"locale-ru-RU","7708":"firebase","7716":"locale-gl-ES","8045":"locale-hu-HU","8277":"locale-fi-FI","8626":"locale-hy-AM","8759":"locale-bs-Latn-BA","8835":"locale-ca-ES","8844":"locale-en-US","8958":"locale-sv-SE","9013":"locale-bg-BG","9331":"locale-pl-PL","9357":"tutorialsPage","9661":"locale-de-DE","9905":"locale-el-GR"}[chunkId]||chunkId) + ".css";
			var fullhref = __webpack_require__.p + href;
			var existingLinkTags = document.getElementsByTagName("link");
			for(var i = 0; i < existingLinkTags.length; i++) {
				var tag = existingLinkTags[i];
				var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
				if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
			}
			var existingStyleTags = document.getElementsByTagName("style");
			for(var i = 0; i < existingStyleTags.length; i++) {
				var tag = existingStyleTags[i];
				var dataHref = tag.getAttribute("data-href");
				if(dataHref === href || dataHref === fullhref) return resolve();
			}
			var linkTag = document.createElement("link");
			linkTag.rel = "stylesheet";
			linkTag.type = "text/css";
			linkTag.onload = resolve;
			linkTag.onerror = function(event) {
				var request = event && event.target && event.target.src || fullhref;
				var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
				err.code = "CSS_CHUNK_LOAD_FAILED";
				err.request = request;
				delete installedCssChunks[chunkId]
				linkTag.parentNode.removeChild(linkTag)
				reject(err);
			};
			linkTag.href = fullhref;

			var head = document.getElementsByTagName("head")[0];
			head.appendChild(linkTag);
		}).then(function() {
			installedCssChunks[chunkId] = 0;
		}));
	}
};